/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Groupslinkresetdone3Inputs */

const en_groupslinkresetdone3 = /** @type {(inputs: Groupslinkresetdone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The old link no longer works.`)
};

const de_groupslinkresetdone3 = /** @type {(inputs: Groupslinkresetdone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der alte Link gilt nicht mehr.`)
};

/**
* | output |
* | --- |
* | "The old link no longer works." |
*
* @param {Groupslinkresetdone3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const groupslinkresetdone3 = /** @type {((inputs?: Groupslinkresetdone3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Groupslinkresetdone3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_groupslinkresetdone3(inputs)
	return de_groupslinkresetdone3(inputs)
});
export { groupslinkresetdone3 as "groupsLinkResetDone" }